import { buildRequestURL } from 'components/common/api'
import {
  EVENT_ACTION_PAGEVIEW,
  EVENT_CATEGORY_MEMBERSHIP,
  saveUserEvent
} from 'components/common/api/UserEvents'
import { toggleTabBar } from 'components/common/helpers/Mobile'
import {
  ROUTE_PAYMENTS_DETAILS,
  ROUTE_TODAY
} from 'components/common/helpers/Paths'
import { navigateTo } from 'components/common/navigation'
import { useEffect } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import './MembershipBenefits.scss'

/**
 * Simple Membership component. Used to display a membership CTA with a simple URI trigger
 */
export default function MembershipBenefits({ setHeaderTitle, setReturnPath }) {
  const history = useHistory()

  // Do we have a returnPath to use from the query string?
  const returnPath = new URLSearchParams(history.location.search).get(
    'returnPath'
  )

  useEffect(() => {
    // Scroll to top of page
    window.scrollTo(0, 0)

    // Update header and return path
    setHeaderTitle('Membership Benefits')
    setReturnPath(returnPath || ROUTE_TODAY)

    // Hide the tab bar on mobile
    toggleTabBar('off')

    // Log access to the page
    saveUserEvent(EVENT_CATEGORY_MEMBERSHIP, EVENT_ACTION_PAGEVIEW)
  }, [returnPath, setHeaderTitle, setReturnPath])

  // If we're not showing the membership, don't render anything
  return (
    <Container className='membership-benefits'>
      <Row>
        <Col>
          <h2 className='title green'>
            Unlock the tools for strong mental health and relationships!
          </h2>
          <p>
            Achieve your goals with our Premium plan - gain full access to our
            entire suite of therapist-created tools.
          </p>
          <h3>What's included</h3>
          <p>Unlimited access to:</p>
          <Row>
            <Col>
              <ul className='features-list'>
                <li>
                  <i className='icon bi bi-check-circle-fill green' /> Courses
                </li>
                <li>
                  <i className='icon bi bi-check-circle-fill green' /> Private
                  Journaling
                </li>
                <li>
                  <i className='icon bi bi-check-circle-fill green' /> Coping
                  Skills
                </li>
                <li>
                  <i className='icon bi bi-check-circle-fill green' /> Practices
                  and Activities
                </li>
                <li>
                  <i className='icon bi bi-check-circle-fill green' /> Daily
                  Remble (Video Tips)
                </li>
              </ul>
            </Col>
            <Col>
              <ul className='features-list'>
                <li>
                  <i className='icon bi bi-check-circle-fill green' />{' '}
                  Relationship Conversation Starters
                </li>
                <li>
                  <i className='icon bi bi-check-circle-fill green' />{' '}
                  Meditations
                </li>
                <li>
                  <i className='icon bi bi-check-circle-fill green' />{' '}
                  Affirmations
                </li>
                <li>
                  <i className='icon bi bi-check-circle-fill green' />{' '}
                  Breathwork
                </li>
                <li>
                  <i className='icon bi bi-check-circle-fill green' /> Articles
                </li>
              </ul>
            </Col>
          </Row>

          <Button
            className='mt-3 w-100'
            size='lg'
            variant='primary'
            onClick={() => {
              // Do we have a returnPath to use from the query string?
              const returnPath = new URLSearchParams(
                history.location.search
              ).get('returnPath')

              // Build the url
              const url = buildRequestURL(ROUTE_PAYMENTS_DETAILS, {
                returnPath
              })

              // Navigate to the payments page
              navigateTo(url, history)
            }}
          >
            <span>Get Started</span>
          </Button>
        </Col>
      </Row>
    </Container>
  )
}
